// extracted by mini-css-extract-plugin
export var activeDot = "_5x-c";
export var buttonContainer = "_5x-9";
export var channelButton = "_5x-a";
export var clickable = "_5x-d";
export var content = "_5x-0";
export var contentFull = "_5x-2";
export var contentThird = "_5x-1";
export var contentWrapper = "_5x-7";
export var description = "_5x-5";
export var heightShort = "_5x-f";
export var image = "_5x-3";
export var imageContainer = "_5x-4";
export var selectButton = "_5x-e";
export var spinnerContainer = "_5x-b";
export var titleContent = "_5x-8";
export var titleWrapper = "_5x-6";